var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video-comp",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.attach.data.videoUrl}}),_vm._v("\n    Sorry, your browser doesn't support embedded videos.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }